import { render } from "./transfere.vue?vue&type=template&id=7b9b2e14&scoped=true"
import script from "./transfere.vue?vue&type=script&lang=js"
export * from "./transfere.vue?vue&type=script&lang=js"

import "./transfere.vue?vue&type=style&index=0&id=7b9b2e14&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9b2e14"]])

export default __exports__